import { render, staticRenderFns } from "./IconChevronDownSmall.vue?vue&type=template&id=809c229e"
import script from "./IconChevronDownSmall.vue?vue&type=script&lang=js"
export * from "./IconChevronDownSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports